import type { IconSvgObject } from './types';

const Rectangular01Icon: IconSvgObject = [
  ["path", { d: "M8.00074 2L4 6H17L21 2H8.00074Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 17.955V8.92411M8 17.955L14.0007 17.9555M8 17.955L4.54551 21.3998M21.0007 2V17.544C21.0007 17.8073 20.8969 18.06 20.7117 18.2472L17 22L4 21.9438V5.98876M17 5.98876V21.3998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Rectangular01Icon;
